// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__OQ1yi","footer":"styles_footer__34H0Y"};